import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';

@Component({
  selector: 'app-buffs',
  templateUrl: './buffs.component.html',
  styleUrls: ['./buffs.component.scss']
})
export class BuffsComponent implements OnInit, OnDestroy {
  public inventory$: Observable<any>|undefined;

  private destroy$ = new Subject();
  buffs:any[]=[{},{}];
  count=0;
  numShow=0;
  max=0;
  move:string='';
  constructor(private mainfacade:MainFacade) { }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setObservables() {
    this.inventory$ = this.mainfacade.inventory$;

    this.inventory$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){

        this.buffs = message.filter((item)=>{
          return item.ItemType == 'Buff';
        });

        let buffSpace = document.getElementById('buffs');
        this.numShow = Math.floor(buffSpace.clientWidth/277);
        this.max = this.buffs.length /this.numShow
     

      }
    });
    this.mainfacade.getInventory();
  }

  next(status){
     if(status=='back' && this.count >= 1){
      this.count -= 1;
      this.move='translateX(-'+(this.count*this.numShow*277) +'px)';
     } 
     else if(status=='forward' && (this.count+1) < this.max){
      this.count += 1;
      this.move='translateX(-'+(this.count*this.numShow*277) +'px)';
     } 
    
  }


}
